import { BID_STATUS } from '../constants';

export const CHECKOUT_LINK_BID_STATUSES = new Set([
	BID_STATUS.PENDING_DEPOSIT,
	BID_STATUS.PENDING_PAYMENT,
]);

export const bidHasActiveCheckoutLink = (bid) => Boolean(bid?.active_checkout_link);

export const statusChangeExpiresCheckoutLink = (oldStatus, newStatus) =>
	CHECKOUT_LINK_BID_STATUSES.has(oldStatus) && oldStatus !== newStatus;
